var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Magic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "szStcY_c-klGUrmyOe524a",
    x1: 18.731,
    x2: 25.236,
    y1: 7.57,
    y2: 44.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#szStcY_c-klGUrmyOe524a)",
    d: "M23.304,7.942l2.596,7.099c1.199,3.278,3.782,5.861,7.06,7.06l7.099,2.596 c1.231,0.45,1.231,2.19,0,2.64l-7.099,2.596c-3.278,1.199-5.861,3.782-7.06,7.06l-2.596,7.099c-0.45,1.231-2.19,1.231-2.64,0 l-2.596-7.099c-1.199-3.278-3.782-5.861-7.06-7.06l-7.099-2.596c-1.231-0.45-1.231-2.19,0-2.64l7.099-2.596 c3.278-1.199,5.861-3.782,7.06-7.06l2.596-7.099C21.113,6.711,22.854,6.711,23.304,7.942z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "szStcY_c-klGUrmyOe524b",
    x1: 36.977,
    x2: 39.035,
    y1: 4.16,
    y2: 15.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aa4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007ad9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#szStcY_c-klGUrmyOe524b)",
    d: "M38.82,4.596l0.623,2.049 c0.279,0.916,0.996,1.634,1.913,1.913l2.049,0.623c0.804,0.245,0.804,1.383,0,1.628l-2.049,0.623 c-0.916,0.279-1.634,0.996-1.913,1.913l-0.623,2.049c-0.245,0.804-1.383,0.804-1.628,0l-0.623-2.049 c-0.279-0.916-0.996-1.634-1.913-1.913l-2.049-0.623c-0.804-0.245-0.804-1.383,0-1.628l2.049-0.623 c0.916-0.279,1.634-0.996,1.913-1.913l0.623-2.049C37.437,3.792,38.575,3.792,38.82,4.596z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Magic);
export default __webpack_public_path__ + "static/media/icons8-magic.d6948b8be57e48456deaf1fe40813979.svg";
export { ForwardRef as ReactComponent };